export const common = {
  'nav.home': 'Hjem',
  'nav.about': 'Om oss',
  'nav.services': 'Tjenester',
  'nav.testimonials': 'Anmeldelser',
  'nav.info': 'Info',
  'nav.payment': 'Bestill time',
  'nav.logo': 'Sofia & Elena',
  'nav.logoAria': 'Gå til hjemmesiden',
  'nav.bookConsultation': 'Bestill nå',
  'nav.bookConsultationAria': 'Bestill en konsultasjon',
  'nav.changeLanguage': 'Bytt språk',
  'nav.language': 'Språk',
  'nav.openMenu': 'Åpne meny',
  'nav.closeMenu': 'Lukk meny',

  'footer.brand': 'Sofia & Elena',
  'footer.tagline': 'Eksperter innen ernæring og kosmetologi',
  'footer.navigation': 'Navigasjon',
  'footer.services': 'Tjenester',
  'footer.contact': 'Kontakt',
  'footer.vipSupport': 'VIP-støtte',
  'footer.fmdProtocol': 'FMD-protokoll',
  'footer.childNutrition': 'Barneernæring',
  'footer.groupIntensive': 'Gruppeintensiv',
  'footer.copyright': '© {{year}} Sofia & Elena. Alle rettigheter reservert.',
};